import { initialize } from '@procore/procore-iframe-helpers';

function launchIntegrationWindow(context, url) {
  context.authentication.authenticate({
    // Some URL on your domain that will start the authentication process.
    url,

    // A function to run if authentication is successful. Payload, you will see
    // below, is sent by you at the last stage of the authentication flow.
    onSuccess(_payload) {
      window.location = '/';
    },

    // A function to run if authentication fails.
    onFailure(error) {
      console.error(error);
      if (error.type === 'canceled_by_user') {
        window.location =
          '/users/integration_sessions/new?canceled_by_user=true&provider=procore';
      } else if (error.type === 'oauth_failure') {
        window.location = '/users/integration_sessions/new?provider=procore';
      } else if (error.type === 'integration_failure') {
        window.location = '/';
      }
    },
  });
}

document.addEventListener('DOMContentLoaded', addEventToIntegrateButton);
document.addEventListener('DOMContentLoaded', successClose);
document.addEventListener('DOMContentLoaded', integrationFailureClose);
document.addEventListener('DOMContentLoaded', oauthFailureClose);

function addEventToIntegrateButton() {
  if (document.getElementById('launch-integration-window')) {
    const context = initialize();
    launchIntegrationWindow(
      context,
      '/integrations/procore_identities/new?provider=procore',
    );
  } else if (document.getElementById('launch-oauth-verification-window')) {
    const context = initialize();
    launchIntegrationWindow(
      context,
      '/integrations/oauth_verifications/new?via_iframe=true',
    );
  }
}

function successClose() {
  if (document.getElementById('integration-success-button')) {
    const context = initialize();
    document
      .getElementById('integration-success-button')
      .addEventListener('click', () => {
        context.authentication.notifySuccess({});
      });
  }
}

function integrationFailureClose() {
  if (document.getElementById('integration-failure-button')) {
    const context = initialize();
    document
      .getElementById('integration-failure-button')
      .addEventListener('click', () => {
        context.authentication.notifyFailure({
          type: 'integration_failure',
          reason: '<%= params[:message] %>',
        });
      });
  }
}

function oauthFailureClose() {
  if (document.getElementById('oauth-failure-button')) {
    const context = initialize();
    document
      .getElementById('oauth-failure-button')
      .addEventListener('click', () => {
        context.authentication.notifyFailure({
          type: 'oauth_failure',
          reason: '<%= params[:message] %>',
        });
      });
  }
}
